/**
 * padForGrid — number of filler cells needed so a list of `n` items fills
 * complete rows of `cols` columns. Always returns 0..cols-1.
 *
 * Examples (cols=3):
 *   n=11 → 1 filler (row 4 has 2/3 slots used)
 *   n=12 → 0 fillers
 *   n=4  → 2 fillers
 */
export function padForGrid(n, cols = 3) {
  if (n <= 0 || cols <= 0) return 0;
  return (cols - (n % cols)) % cols;
}
